// stateManager.js
export class StateManager {
  constructor() {
    this.currentState = null;
    this.listeners = [];
  }

  // Subscribe a listener function that will be called whenever state changes.
  subscribe(listener) {
    if (typeof listener === 'function') {
      this.listeners.push(listener);
    }
  }

  // Unsubscribe a listener.
  unsubscribe(listener) {
    this.listeners = this.listeners.filter((l) => l !== listener);
  }

  // Set the global state and notify all subscribers.
  setState(newState) {
    this.currentState = newState;
    this.listeners.forEach((listener) => listener(newState));
  }

  // Retrieve the current state.
  getState() {
    return this.currentState;
  }
}

// Create a singleton instance for use across your project.
export const stateManager = new StateManager();
